<template>
  <v-layout row>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <template v-slot:activator="{ on }">
        <v-btn :color="completionUploadButtonColor" v-on="on">{{ title }}</v-btn>
        <span class="ml-2 pt-2" v-bind:class="completionStatusColor">{{ completionReportStatus }}</span>
      </template>
      <v-card>
        <v-toolbar color="primary" dark>
          <v-btn dark icon @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-list subheader>

          <v-list-tile>
            <v-list-tile-avatar>
              <v-icon>domain</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title>{{ site.name }}</v-list-tile-title>
          </v-list-tile>

          <v-list-tile v-if="address">
            <v-list-tile-avatar>
              <v-icon>place</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title>{{ address }}</v-list-tile-title>
          </v-list-tile>

          <v-list-tile>
            <v-list-tile-avatar>
              <v-icon>date_range</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title>{{ date }}</v-list-tile-title>
          </v-list-tile>

          <v-list-tile>
            <v-list-tile-avatar>
              <v-icon>access_time</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title>{{ arrangement.work_start_time }} ～ {{ arrangement.work_end_time }}
            </v-list-tile-title>
          </v-list-tile>

          <v-list-tile v-if="train_station">
            <v-list-tile-avatar>
              <v-icon>train</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title>{{ train_station }}</v-list-tile-title>
          </v-list-tile>

          <v-list-tile v-if="bus_stop">
            <v-list-tile-avatar>
              <v-icon>directions_bus</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title>{{ bus_stop }}</v-list-tile-title>
          </v-list-tile>

          <v-list-tile>
            <v-list-tile-avatar>
              <v-icon>receipt</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title>
              <span class="ml-2" v-bind:class="completionStatusColor">{{ completionReportStatus }}</span>
            </v-list-tile-title>
          </v-list-tile>

          <v-list-tile>
            <v-list-tile-avatar>
            </v-list-tile-avatar>
            <v-list-tile-title>
              <input-file-download
                  ref="completionReport-file_download"
                  url_download="completionReports/completionReport/download/0"
              >
              </input-file-download>
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>

        <template v-if="isNewRegistration || isEditableStatus">
          <v-list subheader three-line>
            <v-subheader>完了届提出</v-subheader>
            <v-list-tile class="mt-4" style="height: 100px">
              <v-list-tile-content style="height: 150px">
                <input-file
                    :id="arrangement.id + arrangement.date"
                    ref="completionReport-input_file"
                    :front_flg="true"
                    class="w-100"
                    label="写真を選択"
                    name="completionReport[input_file]"
                    @failed="canSubmit = false"
                    @success="canSubmit = true"
                />
                <v-list-tile-sub-title class="red--text small">写真を選択して下部のアップロードボタンを押してください</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action>
                <v-checkbox
                    v-model="completionReport.consecutive_name_valid_type"
                ></v-checkbox>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ headers.completionReport.consecutive_name_valid_type }}
                </v-list-tile-title>
                <v-list-tile-sub-title>完了届に複数名が記入されている場合はチェックしてください</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" @click="dialog = false">閉じる</v-btn>
            <v-spacer></v-spacer>
            <v-btn :disabled="!canSubmit"
                   color="success" @click="upload()">アップロード
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </template>
        <template v-else>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" @click="dialog = false">閉じる</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </template>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import InputStatic from '../../forms/inputStaticComponent';
import InputCheck from '../../forms/inputCheckComponent';
import InputFile from "../../forms/inputFileComponent";
import InputFileDownload from "../../forms/inputFileDownloadComponent";
import {EnumsMixin} from "../../../mixins/enums";
import moment from "moment";

export default {
  name: "UploadCompletionReportsComponent",
  components: {
    InputCheck,
    InputStatic,
    InputFile,
    InputFileDownload
  },
  mixins: [
    EnumsMixin
  ],
  props: {
    title: String,
    staff: Object,
    corporate: Object,
    branch: Object,
    site: Object,
    arrangement: Object,
    arrangement_frame: Object,
    default_completion_report: Object,
  },
  data() {
    return {
      url_store: "/api/completionReports/completionReport/store",
      url_update: "/api/completionReports/completionReport/update",
      headers: {
        completionReport: {
          staff_id: appUtil.getLang('validation.attributes.completion_report.staff_id'),
          staff_name: appUtil.getLang('validation.attributes.completion_report.staff_name'),
          site_name: appUtil.getLang('validation.attributes.completion_report.site_name'),
          working_day: appUtil.getLang('validation.attributes.completion_report.working_day'),
          file: appUtil.getLang('validation.attributes.completion_report.uploaded_file_id'),
          consecutive_name_valid_type: appUtil.getLang('validation.attributes.completion_report.consecutive_name_valid_type'),
        },
      },
      canSubmit: false,
      tempFile: null,
      completionReport: null,
      dialog: false,
    };
  },
  created() {
    this.completionReport = this.getCompletionReport(this.default_completion_report);
  },
  mounted() {
    if (this.completionReport && this.completionReport.file_id) {
      this.$refs['completionReport-file_download'].uploaded_data = [this.completionReport];
    }
  },
  methods: {
    getCompletionReport(data) {
      let completionReport = data;
      if (!completionReport) {
        completionReport = {
          'completion_report_status_type': null,
          'consecutive_name_valid_type': '09',
          'file_id': null,
        }
      }
      if (completionReport.consecutive_name_valid_type === '01') {
        completionReport.consecutive_name_valid_type = true;
      }
      if (completionReport.consecutive_name_valid_type === '09') {
        completionReport.consecutive_name_valid_type = false;
      }

      return completionReport;
    },
    upload() {
      // エラーをリセット
      this.resetErrors();

      // パラメータを設定
      let url = "";
      let param = "";
      if (!this.completionReport.id) {
        url = this.url_store;
        param = this.getParamsStore();
      } else {
        url = this.url_update;
        param = this.getParamsUpload();
      }

      // 更新処理
      let seqId = this.$root.startApiRequest();
      appUtil.postAction(url, param)
          .then(response => {
            let completionReport = response.data.completionReport;
            completionReport.file = response.data.file;
            this.completionReport = completionReport;
            this.$emit('updateCompletionReport', completionReport);
            this.$refs['completionReport-input_file'].init();
            appUtil.showInfoDialog('完了届提出完了！', 'お疲れさまでした！')
                .then(result => {
                  this.dialog = false;
                });
          })
          .catch(response => {
            if (response.response.data.errors) {
              let errors = response.response.data.errors;
              this.setErrors(errors);
            } else if (response.response.data.message) {
              let message = response.response.data.message;
              appUtil.showErrorDialog('完了届提出エラー', message);
            } else {
              appUtil.showErrorDialog('完了届提出エラー', '想定外のエラーが発生しました。画面を再読み込みしてください。');
            }
          })
          .finally(() => {
            this.$root.endApiRequest(seqId);
          });
    },
    getConsecutiveNameValidType() {
      if (this.completionReport.consecutive_name_valid_type) {
        return '01';
      } else {
        return '09';
      }
    },
    getParamsStore() {
      return {
        'completion_report': {
          'corporate_id': this.corporate.id,
          'branch_id': this.$store.state.auth.branch_id,
          'file_id': this.$refs['completionReport-input_file'].file.response.id,
          'consecutive_name_valid_type': this.getConsecutiveNameValidType(),
        },
        'completion_report_relation_sites': {
          'new': [
            {
              'site_id': this.site.id,
              'start_date': this.arrangement.date,
              'end_date': this.arrangement.date,
            }
          ]
        },
        'completion_report_relation_arrangement_frames': {
          'new': [
            {
              'arrangement_id': this.arrangement.id,
              'arrangement_frame_id': this.arrangement_frame.id,
            }
          ]
        },
      };
    },
    getParamsUpload() {
      return {
        'completion_report': {
          'id': this.completionReport.id,
          'corporate_id': this.corporate.id,
          'branch_id': this.$store.state.auth.branch_id,
          'file_id': this.$refs['completionReport-input_file'].file.response.id,
          'consecutive_name_valid_type': this.getConsecutiveNameValidType(),
          'updated_at': new Date(),
        },
      };
    },
    setErrors(errors) {
      if (errors['application']) {
        appUtil.showErrorDialog('完了届提出エラー', errors['application'][0]);
      }

      if (errors['completion_report.file_id']) {
        this.$refs['completionReport-input_file'].error = errors['completion_report.file_id'][0];
      }
    },
    resetErrors() {
      this.$refs['completionReport-input_file'].error = null;
    }
  },
  computed: {
    isNewRegistration: function () {
      if (!this.completionReport.id) {
        return true;
      }
      return false;
    },
    isEditableStatus: function () {
      // 自身でアップロードしたもの以外は修正不可
      let authUserId = this.$store.state.auth.id;
      if (this.completionReport.staff_id != authUserId) {
        return false;
      }

      return (this.completionReport.completion_report_status_type === '01' ||
          this.completionReport.completion_report_status_type === '02');
    },
    isDisabledStatus: function () {
      return (this.completionReport.completion_report_status_type === '03' ||
          this.completionReport.completion_report_status_type === '04');
    },
    date: function () {
      let date = moment(this.arrangement.date);
      return date.format('YYYY-MM-DD');
    },
    address: function () {
      // 住所を取得
      let prefecture = this.getEnumDescription('Common\\PrefectureType', this.site.prefecture_type);
      let city = this.site.city;
      let address1 = this.site.address_1;
      let address2 = this.site.address_2;
      let address = '';
      if (prefecture) {
        address = address + prefecture;
      }
      if (city) {
        address = address + city;
      }
      if (address1) {
        address = address + address1;
      }
      if (address2) {
        address = address + address2;
      }
      return address;
    },
    train_station: function () {
      // 最寄駅
      let stationRoute = this.site.nearest_station_route;
      let stationName = this.site.nearest_station_name;
      let trainStation = '';
      if (stationRoute) {
        trainStation = trainStation + stationRoute;
      }
      if (stationName) {
        trainStation = trainStation + stationName;
      }

      return trainStation;
    },
    bus_stop: function () {
      // 最寄バス停
      let busRoute = this.site.nearest_bus_route;
      let busName = this.site.nearest_bus_station_name;
      let busStop = busRoute + busName;
      if (busRoute) {
        busStop = busStop + busRoute;
      }
      if (busName) {
        busStop = busStop + busName;
      }
      return busStop;
    },
    completion_report_status_type: function () {
      // 完了届ステータスを設定
      let completionReportStatusType = null;
      if (this.completionReport) {
        completionReportStatusType = this.completionReport.completion_report_status_type;
      }

      return completionReportStatusType;
    },
    completionReportStatus: function () {
      //存在しない場合
      if (!this.completion_report_status_type) {
        return '未提出'
      }
      //未確認の場合
      if (this.completion_report_status_type == '01') {
        return '提出済み'
      }
      //再提出依頼中の場合
      if (this.completion_report_status_type == '02') {
        return '再提出依頼'
      }
      //登録済の場合
      if (this.completion_report_status_type == '03') {
        return '提出済み'
      }
      //確認済の場合
      if (this.completion_report_status_type == '04') {
        return '確認済み'
      }

      return '未提出';
    },
    completionStatusColor: function () {
      if (!this.completion_report_status_type) {
        return 'text-danger';
      }
      if (this.completion_report_status_type == '02') {
        return 'text-danger';
      }

      return 'text-success';
    },
    completionUploadButtonColor: function () {
      if (!this.completion_report_status_type) {
        return 'error';
      }
      if (this.completion_report_status_type == '02') {
        return 'error';
      }

      return 'success';
    },
  },
  watch: {
    completionReport: {
      handler: function (val, oldVal) {
        if (!val) {
          return;
        }

        if (!oldVal) {
          return;
        }

        // ファイルが更新された場合
        if (val.file_id != oldVal.file_id) {
          this.$refs['completionReport-file_download'].uploaded_data = [val];
        }
      },
      deep: true
    },
    default_completion_report: {
      handler: function (val, oldVal) {
        if (!val) {
          return;
        }

        // 完了届を再設定
        this.completionReport = this.getCompletionReport(val);
      },
      deep: true
    }
  }
}
</script>

<style scoped>

</style>
